// extracted by mini-css-extract-plugin
export var noSpinners = "_or-6";
export var percentageInput = "_or-7";
export var variantColor1 = "_or-0";
export var variantColor2 = "_or-1";
export var variantColor3 = "_or-2";
export var variantColor4 = "_or-3";
export var variantColor5 = "_or-4";
export var variantColor6 = "_or-5";